import baseTheme from '../baseTheme';
var MuiCard = {
    root: {
        border: "1px solid " + baseTheme.palette.grey[300],
    },
};
export default MuiCard;
//# sourceMappingURL=MuiCard.js.map